<template>
    <div>
        <div class="flex flex-row justify-between w-full">
            <p class="text-zinc-950 text-lg font-semibold leading-7">Verify Phone</p>
        </div>
        <div class="self-stretch">
            <p class="text-zinc-600 text-sm font-normal leading-5">
                Enter the verification code sent to the below phone number to add it to your Identity Vault. We'll start scanning for
                exposures linked to it.
                <span class="block mt-1">
                    Phone:
                    <span class="font-bold"> {{ data.country_code }} {{ data.phone_number }}</span>
                </span>
            </p>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ModalNames } from '~/types/modals';

//dialolg ref data
const dialogRef =   getDialogRef(ModalNames.PHONE_VERIFICATION);
const data = dialogRef.value.data;
</script>
